<template>
  <v-card flat tile>
    <v-card-title>Shareholders</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="adminAssetOwnership"
        class="mb-12 elevation-1"
        no-data-text="There is no shareholder history."
      >
        <template v-slot:item.amountPaid="{ item }">
          {{ item.pricePerShare * item.shares | numberToMoney }}
        </template>

      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AssetShareholders',

    computed: {
      ...mapGetters([
        'adminAssetOwnership'
      ])
    },

    data: () => ({
      investments: [],

      headers: [
        {
          text: 'Email',
          value: 'owner.emailAddress'
        },
        {
          text: 'Full Name',
          value: 'owner.fullName'
        },
        {
          text: 'Shares Owned',
          value: 'shares'
        },
        {
          text: 'Amount Invested',
          value: 'amountPaid'
        }
      ]
    }),
  }
</script>
